import PriceFormat from '@website/components/utilities/PriceFormat';

type InvoiceRowItemProps = {
  amountZD: number;
  currency: string;
  lineText: React.ReactNode;
  isIndented?: boolean;
  className?: string;
  trClassName?: string;
  amountClassName?: string;
  hideAmount?: boolean;
  roundAmountOff?: boolean;
};

export default function InvoiceRowItem({
  amountZD,
  currency,
  lineText,
  isIndented = false,
  className = '',
  amountClassName = '',
  trClassName,
  hideAmount = false,
  roundAmountOff = false,
}: InvoiceRowItemProps) {
  return (
    <tr className={trClassName}>
      <td
        className={className}
        style={isIndented ? { textIndent: 15 } : undefined}
      >
        {lineText}
      </td>
      <td
        className={`text-end ${amountClassName}`}
        style={{ whiteSpace: 'nowrap' }}
      >
        {!hideAmount && (
          <PriceFormat
            amount={amountZD}
            currencyIso={currency}
            roundAmountOff={roundAmountOff}
          />
        )}
      </td>
    </tr>
  );
}
